import { create } from 'zustand';
import { ContentApi, type GetFeedResponse } from '@shared/api';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';

interface UseFeedStore {
  data: GetFeedResponse[];
  loading: boolean;
  error: string | null;
  getFeed: (request: number, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useFeedStore = create<UseFeedStore>((set) => ({
  data: [],
  loading: false,
  error: null,

  getFeed: ApiUtils.wrapperApi(async (request, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await ContentApi.getFeed(request, signal);
      set({ data: result ?? [], loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: [], loading: false, error: null }),
}));
